(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["header"]) return;
  try {
    

    $('.meganav__link--active').parents('.site-nav__item').addClass('site-nav--active');


  } catch(e) { console.error(e); }
})();

})();
